import { useMutation } from 'react-query';

import type { CreatePasswordDto } from '@identity/application/dtos';
import { getAccountUseCases } from '@identity/composition';
import { useIdentityFlow } from '@identity/presentation/context';

/**
 * Replaces the password of the account that is signed in.
 *
 * It drives the same write as the creation, with the password being replaced filled in. `Required`
 * is what keeps that field from being forgotten here: the write accepts it as optional because the
 * account that has no password yet has nothing to cite, and this flow always does.
 *
 * It patches nothing in the cache: the date this screen changed is refreshed by the closing screen,
 * which invalidates the account status so the profile comes back with the new one.
 */
export const useChangePassword = () => {
  const flow = useIdentityFlow();
  const { createPassword } = getAccountUseCases(flow);

  return useMutation<void, Error, Required<CreatePasswordDto>>((input) => createPassword.execute(input));
};
